import api from '@/services/groupHead'
export default {
  namespaced: true,
  state: {
      groupList: null
  },
  getters: {

  },
  mutations: {
    fetchList(state, groupList) {
        state.groupList = groupList
    }
  },
  actions: {
    async fetchList(context, data) {
        const grouplist = (await api.fetchList()).data
        await context.commit('fetchList', grouplist) 
    }
  }
}